if (!customElements.get('request-form')) {
  customElements.define('request-form', class RequestForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.formSuccess = this.querySelector('[data-request-form-success]');

      if (this.form) {
        document.addEventListener('request-form:sync', this.syncOptions.bind(this));
      }

      if (this.formSuccess) {
        const productInfo = document.querySelector('[data-product-info]');
        if (!productInfo) return;

        productInfo.classList.remove('product__info-container--has-shelves-dropdown');
        productInfo.classList.add('product__info-container--show-success-message');
      }
    }

    syncOptions (evt) {
      if (!evt.detail.target) return;
      const option = this.form.querySelector(`[data-variant-option='${evt.detail.target.name}']`);
      if (option) {
        option.value = evt.detail.hasOwnProperty('values') ? evt.detail.values : evt.detail.target.value;
      }
    }
  });
}
